import React from "react";
import { Flame, Award, MapPin, Clock } from "lucide-react";

const TEXTURE_BG = "https://static.prod-images.emergentagent.com/jobs/06b5109e-d3c1-4bd0-9f14-6ae825c1cf11/images/70d55d34baa047b87531924509ccce11c8cb74b95ed1004e165f3d595fb208b1.png";
const HERO = "https://images.unsplash.com/photo-1544025162-d76694265947?w=1600&q=80";

const About = () => {
  return (
    <div data-testid="about-page">
      <section className="relative h-[60vh] flex items-end overflow-hidden">
        <img src={HERO} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-ink-900/70 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pb-16">
          <div className="text-brand font-display text-sm tracking-[0.4em] mb-2">/ OUR STORY</div>
          <h1 className="font-display text-6xl sm:text-8xl text-cream leading-none">SMOKE.<br/>FIRE.<br/><span className="text-brand">EDGE.</span></h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-20 text-[#C8C4BB] leading-relaxed text-lg space-y-6">
        <p>Blazing Edge BBQ started in a backyard on the Central Coast, with one stick-burner, one pitmaster, and a stubborn belief that there are no shortcuts to great barbeque.</p>
        <p>Every brisket is hand-trimmed, rubbed with our own blends, and smoked over local hardwood for 12 hours or more. No shortcuts. No injections. Just fire, time and meat.</p>
        <p>We pickup-only from Gosford Showgrounds — small batch, big flavour. When it's gone, it's gone. So come hungry, and come early.</p>
      </section>

      <section className="border-y border-ink-600" style={{ backgroundImage: `url(${TEXTURE_BG})`, backgroundSize: "cover" }}>
        <div className="bg-ink-900/85 py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { icon: <Award className="text-brand" size={28} />, t: "12 HR", s: "Average smoke time" },
              { icon: <Flame className="text-brand" size={28} />, t: "100%", s: "Hardwood smoked" },
              { icon: <MapPin className="text-brand" size={28} />, t: "1 SPOT", s: "Gosford Showgrounds" },
              { icon: <Clock className="text-brand" size={28} />, t: "SAT/SUN", s: "Weekly pickups" },
            ].map((s) => (
              <div key={s.t} className="border border-ink-600 p-6 bg-ink-800/60">
                {s.icon}
                <div className="font-display text-4xl text-cream mt-3 leading-none">{s.t}</div>
                <div className="text-[#A19D94] text-sm mt-2 tracking-widest">{s.s}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
